import logo from "./logo.svg";
import "./App.css";
import Navigator from "./Router/Navigator";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { investorApi } from "./api/api";
import { updateSubscription,kycStatus } from "./redux/reducers/userReducer";
import { setThemeData } from "./redux/reducers/themeValueReducer";
// import { generateToken , messaging} from "./firebase";
// import { onMessage } from "firebase/messaging";

function App() {
  const userId = useSelector((state) => state.user.userId);
  const user= useSelector((state)=>state.user);
  console.log(user);
  const currentTheme = useSelector((state) => state.themeValue.theme);
  const dispatch = useDispatch();

  // useEffect(()=>{
  //  generateToken(userId);
  //  onMessage(messaging, (payload) => {
  //   console.log(payload);
  //  })
  // },[])

 useEffect(() => {
  const getSubscription = async () => {
    try {
      // ✅ Always fetch theme
      const themeRes = await investorApi.getThemeColors(currentTheme);
      if (themeRes.data) {
        dispatch(setThemeData(themeRes.data));
      }

      // ✅ Only fetch subscription if user logged in
      if (userId) {
        const subscriptionRes = await investorApi.getUserSubscriptionStatus(userId);
        if (subscriptionRes.status === 200) {
          const { isSubscribed, kycStatus: isKyc } = subscriptionRes.data;
          dispatch(updateSubscription({ userId, isSubscribed }));
          dispatch(kycStatus({ userId, isKyc }));
        }
      }

    } catch (err) {
      console.error("Error fetching subscription or theme:", err);
    }
  };

  getSubscription();
}, [dispatch, userId, currentTheme]);

  

  return <Navigator />;
}

export default App;
